import React, { useState } from 'react';
import './brand-lift-study.scss';
import { DashboardHeader } from '../../atoms';
import { BlsInsights, DashContentFooter } from '../../molecules';
import { DashboardContext } from '../../../context';

function BrandLiftStudy() {
  const [dashData, setDashData] = useState({});  
      return (
        <DashboardContext.Provider value={{ dashData, setDashData }}>
          <div className='row no-gutters'>
            <div className='no-gutters dash-left-wrapper'>
              <DashboardHeader />
              <BlsInsights/>
              <DashContentFooter />
            </div>
    
          </div>
    
        </DashboardContext.Provider>
      );
}

export default BrandLiftStudy;

